export function formatDate(inputDate) {
  // Преобразование строки в формат даты
  const date = new Date(inputDate);

  // Определение списка месяцев
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  // Получение дня, месяца и года
  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  // Форматирование месяца в требуемом формате
  const formattedMonth = months[monthIndex];

  // Добавление нуля к числам, если они меньше 10
  const formattedDay = day < 10 ? `0${day}` : day;

  // Возвращение отформатированной даты
  return `${formattedMonth} ${formattedDay}, ${year}`;
}
